/**
 * Canonical list URL search: page 1 has no `page` query param; page > 1 sets `?page=N`.
 * Used by TanStack Router `validateSearch` so `search` is optional on Link/navigate (page defaults to 1).
 */
export type ListPageSearchParams = { page?: number };

export function validateListPageSearch(
  search: Record<string, unknown>,
): ListPageSearchParams {
  const parsedPage = search.page ? parseInt(search.page as string, 10) || 1 : 1;
  return parsedPage > 1 ? { page: parsedPage } : {};
}
